<template>
    <el-pagination style="float: right;margin-bottom: 10px;" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :current-page="currentPage" :pager-count="5" :page-sizes="[10, 15, 20, 25, 30]"
        :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
</template>

<script>
export default {
    props: {
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {

        }
    },
    methods: {
        handleCurrentChange(value) {
            console.log(value, "486970-5");
            this.$emit("updateCurrentPage", value);
        },
        handleSizeChange(value) {
            console.log(value, "486970-5trt");
            this.$emit("updatePageSize", value);
        }
    }
}
</script>

<style lang="less" scoped>
.el-pagination {
    --el-text-color-regular: #333;
    // --el-disabled-bg-color: none;
    --el-text-color-placeholder: #333;
    --el-pagination-button-bg-color: none;
    --el-pagination-hover-color: #1677ff;
    --el-pagination-button-width: 30px;
    --el-pagination-button-height: 30px;
    // --el-color-primary: #1677ff;
    --el-pagination-font-size: 12px;

    .btn-prev {
        border: 1px solid black;
    }

    ::v-deep .el-pagination__sizes {
        margin-right: 0px !important;
    }
}
</style>